import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GrantEffects } from './effects';
import { grantFeatureKey, reducer } from './reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([GrantEffects]),
    StoreModule.forFeature(grantFeatureKey, reducer),
  ],
})
export class GrantModule {}
